import React from "react";

import { useFieldValue } from "2g-form";

import TypyZdrojuSwitch from "b2b/components/form-switches/TypyZdrojuSwitch";
import ZdrojeSwitch from "b2b/components/form-switches/ZdrojeSwitch";
import ProduktySwitch from "b2b/components/form-switches/ProduktySwitch";
import TypyZdrojuOnlySwitch from "b2b/components/form-switches/TypyZdrojuOnlySwitch";

export function FormSwitchesExample() {
  const typZdroje = useFieldValue("typZdroje");
  const zdroj = useFieldValue("zdroj");
  return (
    <>
      <div data-testid="typy-zdroju">
        <TypyZdrojuSwitch />
        {typZdroje ? <ZdrojeSwitch typZdroje={typZdroje} /> : undefined}
        {zdroj ? <ProduktySwitch zdroj={zdroj} /> : undefined}
      </div>
      <br />
      <br />
      <TypyZdrojuOnlySwitch label="jen typy zdroju" path="typZdrojeOnly" />
    </>
  );
}

export default React.memo(FormSwitchesExample);
